<script>

export default {
  props: ['file', 'label', 'limit'],
  data() {
    return {
      files: this.file,
      labelInput: this.label,
      remove: false,
      errors: '',
      preview: this.limit == 'image' || this.limit == 'images' ? true : false
    }
  },
  computed: {
    formattedName() {
      if (this.files && typeof this.files === 'string') {
        return this.files
      }

      if (!this.files) {
        return null
      }

      return this.files[0].name
    }
  },
  methods: {
    removeFile() {
      this.files = null
      this.remove = true
    },
    changeFile(files) {
      this.preview = false
      this.limitFileType(files)
    },
    limitFileType(files) {
      if (!this.limit) {
        this.files = files
        return
      }

      let file = files[0]
      let errors = ''

      if ((this.limit == 'image' || this.limit == 'images') && !file.type.startsWith('image/')) {
        errors = 'Sorry, file must be an image.'
      }

      if (this.limit == 'pdf' && file.type !== 'application/pdf') {
        errors = 'Sorry, file must be a PDF.'
      }

      if (errors) {
        this.errors = errors
      } else {
        this.errors = ''
        this.files = files
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      preview: this.preview,
      errors: this.errors,
      inputProps: {
        value: this.formattedName ? this.formattedName : ''
      },
      inputEvents: {
        change: e => (this.changeFile(e.target.files))
      },
      removeProps: {
        value: this.remove
      },
      removeEvents: {
        click: e => (this.removeFile())
      },
      labelProps: {
        value: this.labelInput
      },
      labelEvents: {
        input: e => (this.labelInput = e.target.value)
      }
    })
  }
}
</script>
